import { useDashboardCounts } from "@/common/api/use-dashboard-counts";
import { proxyImageUrl } from "@/lib/snipeit/client";
import { Loader2 } from "lucide-react";

export function DashboardGrid() {
  const { items, isLoading } = useDashboardCounts();

  if (items.length === 0) return null;

  return (
    <div className="flex h-full w-full flex-col">
      <div className="grid h-full auto-rows-fr grid-cols-2 gap-3 sm:grid-cols-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="border-border bg-card text-foreground flex flex-col items-center justify-center gap-3 rounded-xl border p-4 shadow-sm"
          >
            {proxyImageUrl(item.image) && (
              <img
                src={proxyImageUrl(item.image)!}
                alt={item.name}
                className="h-14 w-14 object-contain mix-blend-multiply dark:mix-blend-screen dark:invert"
              />
            )}
            {isLoading ? (
              <Loader2 className="text-muted-foreground h-7 w-7 animate-spin" />
            ) : (
              <span className="text-primary text-4xl font-bold tabular-nums">{item.count}</span>
            )}
            <span className="text-muted-foreground line-clamp-2 text-center text-sm font-medium">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
